export const Ico16X = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="8.00146" cy="7.99805" r="8" fill="#E8EAEE" />
      <path d="M4.99658 5L11.0018 11.0052" stroke="#646468" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M10.9995 5L4.9943 11.0052" stroke="#646468" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};
